export interface BrandingFontConfig {
  fontFamily: string;
  fontWeight?: string | number;
  fontStyle?: string;
  fontDisplay?: string;
  fontSrc?: string;
}

export interface BrandingConfig {
  siteTitle: string;
  logoPath: string;
  resourcesTeacherLogoPath: string;
  colors: {
    [key: string]: string;
  };
  font?: BrandingFontConfig;
}

// Project Explore branding — primary brand for PE chassis
const peBranding: BrandingConfig = {
  siteTitle: "Project Explore",
  logoPath: "/images/pe-logo-transparent-header.png",
  resourcesTeacherLogoPath: "/images/pe-logo.png",
  colors: {
    // Covers — dark forest green
    coverColorOne: "#3b5839",
    coverColorTwo: "#2d4428",
    coverColorThree: "#304a2e",
    coverColorTextPrimary: "#fff",
    coverColorTextSecondary: "rgb(220 235 210)",

    coverBtnPrimary: "#fff",
    coverBtnTextPrimary: "#3b5839",
    coverBtnBorderPrimary: "transparent",

    coverBtnSecondary: "transparent",
    coverBtnTextSecondary: "#fff",
    coverBtnBorderSecondary: "#fff",

    // Icons — gold accent
    iconColor: "#976634",

    // Buttons
    btnPrimary: "#3b5839",
    btnSecondary: "#fff",
    btnPrimaryText: "#fff",
    btnSecondaryText: "#3b5839",
    btnPrimaryBorder: "transparent",
    btnSecondaryBorder: "#3b5839",

    // Headings
    textPrimary: "#1a1a1a",
    textSecondary: "rgb(75 85 99)",
    background: "#fafafa",
    accent: "#3b5839",

    // Header
    headerBackground: "#fff",
    headerPrimaryText: "rgb(55 65 81)",
    headerHoverText: "#3b5839",
    headerActiveText: "#3b5839",
    headerBorder: "rgb(229 231 235)",

    // Footer
    footerBackground: "#fafafa",
    footerPrimaryText: "rgb(17 24 39)",
    footerSecondaryText: "rgb(75 85 99)",
  },
};

// PFL Academy branding — retained for reference, not active
const defaultBranding: BrandingConfig = {
  siteTitle: "PFL Academy",
  logoPath: "/images/logo.svg",
  resourcesTeacherLogoPath: "/images/logo.svg",
  colors: {
    coverColorOne: "#4338ca",
    coverColorTwo: "#6d28d9",
    coverColorThree: "#3730a3",
    coverColorTextPrimary: "#fff",
    coverColorTextSecondary: "rgb(224 231 255)",
    coverBtnPrimary: "#fff",
    coverBtnTextPrimary: "#3730a3",
    coverBtnBorderPrimary: "transparent",
    coverBtnSecondary: "transparent",
    coverBtnTextSecondary: "#fff",
    coverBtnBorderSecondary: "#fff",
    iconColor: "#9333ea",
    btnPrimary: "rgb(79 70 229)",
    btnSecondary: "#fff",
    btnPrimaryText: "#fff",
    btnSecondaryText: "rgb(79 70 229)",
    btnPrimaryBorder: "transparent",
    btnSecondaryBorder: "rgb(79 70 229)",
    textPrimary: "#000",
    textSecondary: "rgb(75 85 99)",
    background: "#fafafa",
    accent: "rgb(79 70 229)",
    headerBackground: "#fff",
    headerPrimaryText: "rgb(55 65 81)",
    headerHoverText: "rgb(79 70 229)",
    headerActiveText: "rgb(79 70 229)",
    headerBorder: "rgb(229 231 235)",
    footerBackground: "#fafafa",
    footerPrimaryText: "rgb(17 24 39)",
    footerSecondaryText: "rgb(75 85 99)",
  },
};

// Edia branding configuration
const ediaBranding: BrandingConfig = {
  siteTitle: "Edia PFL",
  logoPath: "/images/EdiaLogo.png",
  resourcesTeacherLogoPath: "/images/EdiaLogo.png",
  colors: {
    //Covers colors
    coverColorOne: "#FFFFFF",
    coverColorTwo: "#F4F4F4",
    coverColorThree: "#E0E0E0",
    coverColorTextPrimary: "#111111",
    coverColorTextSecondary: "#333",

    coverBtnPrimary: "#ff0",
    coverBtnTextPrimary: "#000",
    coverBtnBorderPrimary: "transparent",

    coverBtnSecondary: "#ffffff",
    coverBtnTextSecondary: "#000",
    coverBtnBorderSecondary: "transparent",

    //Icons colors
    iconColor: "#000",

    //Button colors
    btnPrimary: "#ff0",
    btnSecondary: "#fff",
    btnPrimaryText: "#000",
    btnSecondaryText: "#000",
    btnPrimaryBorder: "transparent",
    btnSecondaryBorder: "transparent",

    //Headings colors
    textPrimary: "#111111",
    textSecondary: "#333",
    background: "#f5f5f5",
    accent: "#FFFF00",

    //Header
    headerBackground: "#fff",
    headerPrimaryText: "#000",
    headerHoverText: "#5f5f5f",
    headerBorder: "rgb(229 231 235)",
    headerActiveText: "#000",

    //Footer
    footerBackground: "#000",
    footerPrimaryText: "#fff",
    footerSecondaryText: "#ffffff80",
  },
  font: {
    fontFamily: "Inter Variable",
    fontWeight: "100 900",
    fontStyle: "normal",
    fontDisplay: "swap",
    fontSrc: "/src/assets/fonts/edia/InterVariable.c504db5c06caaf7cdfba.woff2",
  },
};

const brand = import.meta.env.VITE_BRAND || "project-explore";

export const brandingConfig: BrandingConfig & { brand: string } = {
  ...(brand.toLowerCase() === "edia"
    ? ediaBranding
    : brand.toLowerCase() === "pflacademy"
    ? defaultBranding
    : peBranding),
  brand,
};
